export enum ClaimStatusEnum {
  'Open' = 0,
  'InProgress' = 1,
  'Closed' = 2,
  'Cancelled' = 3
}